import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-dash-dash",
  "use": "icon-dash-dash-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"icon-dash-dash\"><path d=\"M26 15h-9v2h9zm-11 0H6v2h9z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol